

const getters = {
    bank: (state) => state.bank,
    id: (state) => state.id,
    loading: state => state.loading
};

export default getters;